import React from "react";
import {
  ButtonHTMLType,
  ButtonShape,
  ButtonSize,
  ButtonType,
} from "../../enums/ButtonAttributesEnums";
import { Badge, Button } from "antd";
import ConditionalRender from "../ConditionalRender";
import clsx from "clsx";
import styles from "./TNButton.module.scss";

interface TNButtonProps {
  shape?: ButtonShape;
  onClick?: () => void;
  backgroundColor?: string;
  borderColor?: string;
  name?: string;
  type?:
    | ButtonType.DEFAULT
    | ButtonType.PRIMARY
    | ButtonType.LINK
    | ButtonType.TEXT
    | ButtonType.GHOST;
  size?: ButtonSize.LARGE | ButtonSize.MEDIUM | ButtonSize.SMALL;
  disabled?: boolean;
  block?: boolean;
  loading?: boolean;
  htmlType?: ButtonHTMLType.BUTTON | ButtonHTMLType.SUBMIT;
  className?: string;
  dark?: boolean;
  light?: boolean;
  icon?: React.ReactNode;
  text?: React.ReactNode;
  afterTitle?: boolean;
  customStyles?: React.CSSProperties;
  danger?: boolean;
  ghost?: boolean;
  badgeCount?: number;
  clearFilterButton?: boolean;
  filterButton?: boolean;
  materialPriceErrorButton?: boolean;
}
const TNButton = (props: TNButtonProps) => {
  const {
    onClick,
    type,
    size,
    disabled,
    loading,
    block,
    htmlType,
    name,
    shape,
    icon,
    text,
    className,
    afterTitle = false,
    customStyles,
    danger,
    ghost,
    badgeCount,
    clearFilterButton,
    filterButton,
    materialPriceErrorButton,
    ...restProps
  } = props;
  const buttonClass = clsx(
    className,
    clearFilterButton && styles.clearFilter,
    filterButton && styles.filterButton,
    materialPriceErrorButton && styles.materialErrorButton,
  );
  return (
    <Button
      {...restProps}
      htmlType={htmlType}
      shape={shape ?? ButtonShape.ROUND}
      onClick={onClick}
      type={type ?? ButtonType.PRIMARY}
      size={size}
      name={name}
      disabled={disabled}
      ghost={ghost}
      danger={danger}
      loading={loading}
      block={block}
      className={buttonClass}
      style={customStyles}
    >
      <ConditionalRender visible={icon && !afterTitle && text}>
        <span className={styles.buttonIconLeft}>{icon}</span>
      </ConditionalRender>

      <ConditionalRender visible={text}>
        <span>{text}</span>
      </ConditionalRender>

      <ConditionalRender visible={badgeCount}>
        <span className={styles.badgeContainer}>
          <Badge count={badgeCount} />
        </span>
      </ConditionalRender>

      <ConditionalRender visible={icon && afterTitle && text}>
        <span className={styles.buttonIconRight}>{icon}</span>
      </ConditionalRender>

      <ConditionalRender visible={icon && !text}>
        <span>{icon}</span>
      </ConditionalRender>
    </Button>
  );
};

export default TNButton;
